import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';
import DiscountStrip from './component/DiscountStrip'; 

export default function Plans() {
  const [dark, setDark] = useState(true);
  const navigate = useNavigate();

  const handleSelectPlan = (requestedPlan, planType, price) => {
    const token = localStorage.getItem('token');
    const redirectState = {
      to: '/PlanWizard',
      state: { requestedPlan, planType, price }
    };

    if (!token) {
      localStorage.setItem('redirectAfterLogin', JSON.stringify(redirectState));
      navigate('/login');
      return;
    }

    navigate('/PlanWizard', redirectState);
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="bg-white dark:bg-[#0e1015] text-black dark:text-white font-vazir min-h-screen transition-all duration-300">
        {/* Discount Banner */}
    <DiscountStrip />


                  <a href='/'>
          <img src="/logo.png" alt="logo" className="w-16 h-16 mx-auto mb-4"/>
          </a>
        <h1 className="text-2xl font-bold text-center mb-8">انتخاب پلن مورد نظر</h1>
        <p className="text-center text-sm text-gray-600 dark:text-gray-400 mb-10">
          لطفاً ابتدا وارد شوید تا بتوانید برنامه کامل را دریافت کنید
        </p>

        <div className="grid gap-8 md:grid-cols-2">
          {/* پلن عادی */}
          <div className="border dark:border-gray-700 rounded-xl p-6 shadow-md bg-gray-50 dark:bg-[#1c1f2b] text-center">
            <h2 className="text-xl font-bold mb-4">پلن عادی</h2>
            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1 mb-6">
              <li>✔ gpt-o4</li>
              <li>✔ قیمت اقتصادی</li>
              <li>✔ مدت آماده سازی:حداکثر ۳ ساعت</li>
              <li>✔ محدودیت ساعتی ایجاد برنامه</li>
            </ul>

            <div className="grid gap-4 text-sm text-gray-800 dark:text-white mb-6">
              <div className="bg-white dark:bg-[#2a2f3b] p-4 rounded-xl border dark:border-gray-600">
                <p className="font-semibold">برنامه تمرینی: <span className="text-blue-500">۲۵۰،۰۰۰ تومان</span></p>
                <button onClick={() => handleSelectPlan(1, 1, 250000)} className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-1 rounded-xl text-sm">انتخاب</button>
              </div>
              <div className="bg-white dark:bg-[#2a2f3b] p-4 rounded-xl border dark:border-gray-600">
                <p className="font-semibold">برنامه تغذیه و مکمل: <span className="text-blue-500">۲۵۰،۰۰۰ تومان</span></p>
                <button onClick={() => handleSelectPlan(2, 1, 250000)} className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-1 rounded-xl text-sm">انتخاب</button>
              </div>
              <div className="bg-white dark:bg-[#2a2f3b] p-4 rounded-xl border dark:border-gray-600">
                <p className="font-semibold">برنامه تمرینی و تغذیه و مکمل: <span className="text-blue-500">۴۰۰،۰۰۰ تومان</span></p>
                <button onClick={() => handleSelectPlan(3, 1, 400000)} className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-1 rounded-xl text-sm">انتخاب</button>
              </div>
            </div>


          </div>

          {/* پلن پرمیوم */}
          <div className="border-2 border-purple-600 rounded-xl p-6 shadow-md bg-white dark:bg-[#1c1f2b] text-center">
            <h2 className="text-xl font-bold mb-4 text-purple-600">پلن پرمیوم</h2>
            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1 mb-6">
              <li>✔ gpt-o4</li>
              <li>✔ تمرین + رژیم + مکمل</li>
              <li>✔ بیمه ورزشی</li>
              <li>✔ بازبینی توسط مربی</li>
              <li>✔ اصلاح برنامه در صورت نیاز</li>
              <li>✔ مدت آماده سازی:حداکثر ۱ ساعت</li>
              <li>✔ بدون محدودیت ساعت ایجاد برنامه</li>
            </ul>
            <div className="bg-white dark:bg-[#2a2f3b] p-4 rounded-xl border dark:border-gray-600">
              <p className="font-semibold">برنامه کامل پرمیوم: <span className="text-purple-600">۸۰۰،۰۰۰ تومان</span></p>
              <button onClick={() => handleSelectPlan(3, 2, 800000)} className="mt-2 bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-xl text-sm">انتخاب</button>
            </div>
          </div>
        </div>

        {/* <button onClick={() => setDark(!dark)} className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center">
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button> */}
      </div>
    </div>
  );
}
